import React, { use } from "react";
import ServicePage from "../components/ServicePage";
import bannerimg from "../../media/bannerimg.jpg";
import heroImg from "../../media/accountingmain.jpg";
import sideImg1 from "../../media/grantsimg1.jpg";
import sideImg2 from "../../media/grantsimg2.jpg";
import ctaBg from "../../media/servicesidecta.png";
import usePageTitle from "../components/usePageTitle";

const Grants = () => {
  usePageTitle("Grants");
  return (
    <ServicePage
      title="Grants"
      breadcrumb="Grants"
      bgImage={bannerimg}
      heroImg={heroImg}
      sectionTitle="Grant Management and Compliance You Can Trust"
      description="Grants come with tremendous opportunities—and equally complex responsibilities. Aspen SR specializes in comprehensive grant accounting and compliance services for educational institutions, nonprofits, and government-funded programs. From pre-award budget design and post-award reporting to ongoing monitoring and audit support, we help ensure your funding is used effectively and in full compliance with federal, state, and local regulations. Our team has extensive experience with OMB Uniform Guidance, state fiscal rules, and agency-specific requirements, making us a trusted partner in managing restricted funds."
      overviewItems={[
        "End-to-end grant accounting and compliance services.",
        "Pre-award budget design and justification support.",
        "Post-award reporting and documentation assistance.",
        "Expertise in OMB Uniform Guidance and agency-specific rules.",
      ]}
      featureItems={[
        {
          icon: "bi-journal-check",
          title: "Compliance Expertise",
          text: "We navigate complex regulations with precision and experience.",
        },
        {
          icon: "bi-building",
          title: "Institutional Focus",
          text: "Tailored services for nonprofits, education, and government grants.",
        },
        {
          icon: "bi-clock-history",
          title: "Full Lifecycle Support",
          text: "From application to audit—we support every grant stage.",
        },
      ]}
      faqList={[
        {
          id: 1,
          question: "What types of grants do you support?",
          answer:
            "We provide services for federal, state, and local government grants, as well as private foundation and institutional grants.",
        },
        {
          id: 2,
          question: "Can you assist with audit preparation?",
          answer:
            "Yes, our team provides complete audit support, helping ensure documentation, compliance, and readiness for external or internal audits.",
        },
        {
          id: 3,
          question: "Do you help with budget creation before grant approval?",
          answer:
            "Absolutely. We assist with pre-award budget planning, justification, and alignment with grantor guidelines.",
        },
        {
          id: 4,
          question: "How do you stay updated on changing grant policies?",
          answer:
            "We closely monitor OMB updates, fiscal rules, and agency guidance to ensure our clients remain compliant with current standards.",
        },
      ]}
      sideImage1={sideImg1}
      sideImage2={sideImg2}
      ctaBg={ctaBg}
      phoneNumber="(+1) 720-412-7990"
    />
  );
};

export default Grants;
